import React, { memo } from 'react';

import { Card, Skeleton } from 'antd';

const MessageCardSkeleton: React.FC = () => {
  return (
    <Card
      style={{
        width: '100%',
        height: 'max-content',
      }}
      bordered={false}
      bodyStyle={{ padding: 8 }}
      className="message-card--skeleton"
    >
      <Skeleton
        avatar={{ shape: 'circle', size: 40 }}
        title={{
          width: 150,
          style: { marginTop: 0, marginBottom: 8, height: 12 },
        }}
        paragraph={{
          rows: 1,
          style: { width: '100%', maxWidth: 300, margin: 0 },
        }}
        round
        active
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      />
    </Card>
  );
};

export default memo(MessageCardSkeleton);
